var $10d7c2a1d55e74cf$exports = {};
$10d7c2a1d55e74cf$exports = {
    "longPressMessage": `Dugo pritisnite ili pritisnite Alt + strelicu prema dolje za otvaranje izbornika`
};


export {$10d7c2a1d55e74cf$exports as default};
//# sourceMappingURL=hr-HR.mjs.map
